import axiosInstance from '@common/services/axiosIntance/axiosService';
import { getTokenKey } from '@common/constants/shared';
import { loginSuccess } from '@common/redux/slice/auth';
import store from '@common/redux/store';
import AsyncStorage from '@react-native-async-storage/async-storage';

export type DodaCampusLoginInput = {
  appId: string;
  screenUuid: string;
  objectId: string;
  email: string;
  password: string;
};

/**
 * Calls the doda Campus login endpoint (click-backend `/doda-campus-login`,
 * MIK-4869 Phase 2) and, on success, stores the returned session token and
 * updates auth state the same way every other login flow does. Throws on
 * failure -- the caller (DodaLogin's tap handler) decides what to show.
 */
export const useDodaCampusLoginAction = () => {
  const dodaCampusLogin = async (data: DodaCampusLoginInput): Promise<void> => {
    const response = await axiosInstance({
      method: 'POST',
      url: '/doda-campus-login',
      data,
    });
    const { accessToken, userPreview } = response.data;
    await AsyncStorage.setItem(getTokenKey(), accessToken);
    store.dispatch(loginSuccess({ user: userPreview }));
  };

  return { dodaCampusLogin };
};
export type DodaCampusLoginActionType = ReturnType<
  typeof useDodaCampusLoginAction
>;
